import React, {Component} from 'react';
import classes from './Toolbar.css';
import {Link} from 'react-router-dom';
import M from 'materialize-css';


// Reusable Nav bar component from Materialize
class Toolbar extends Component
{
    // initializes the Javascript for the mobile 
    componentDidMount(){
        document.addEventListener('DOMContentLoaded', function() {
            var elems = document.querySelectorAll('.sidenav');
            var instances = M.Sidenav.init(elems, {});
          });
      }
    render()
    {

        return (
        <div>
            <nav>
                <div class="nav-wrapper indigo darken-4">
                  <a href="http://cartertaylor.tk" class="brand-logo ">Carter Taylor</a>
                  <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons">menu</i></a>
                  <ul class="right hide-on-med-and-down">
                    <li><a href="http://cartertaylor.tk">Home</a></li>
                    <li><a href="http://cartertaylor.tk/projects/api">API</a></li>
                    <li class="active"><a href="http://cartertaylor.tk/projects/build/">React (BurgerBuilder)</a></li>
                    <li><a href="http://cartertaylor.tk/projects/Lightsout/">Lights Out</a></li>
                  </ul>
                </div>
              </nav>
              <ul class="sidenav" id="mobile-demo">
                <li><a href="http://cartertaylor.tk">Home</a></li>
                <li><a href="http://cartertaylor.tk/projects/api">API</a></li>
                <li class="active"><a href="http://cartertaylor.tk/projects/build/">React (BurgerBuilder)</a></li>
                <li><a  href="http://cartertaylor.tk/projects/Lightsout/">Lights Out</a></li>
              </ul>      
        </div>
        );
    };
}

export default Toolbar;


// WEBPACK FOOTER //
// ./src/components/Navigation/ToolBar/Toolbar.js